import React, { useState, useEffect } from 'react';
import CustomDialog from '../components/CustomDialog';
import AdminNav from './AdminNav';

function AdminProfile() {
  const [profile, setProfile] = useState({
    name: '',
    email: '',
    role: 'ADMIN'
  });
  const [dialog, setDialog] = useState(null);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user) {
      setProfile({
        name: user.name || '',
        email: user.email || '',
        role: user.role || 'ADMIN'
      });
    }
  }, []);

  const handleUpdate = async (e) => {
    e.preventDefault();
    setDialog({ message: 'Profile updated successfully', type: 'success', onClose: () => setDialog(null) });
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = '/login';
  };

  return (
    <>
      <AdminNav onLogout={handleLogout} />
      <div className="container" style={{ padding: '40px 20px', maxWidth: '600px', margin: '180px auto 0 auto' }}>
      <h2 style={{ fontSize: '32px', fontWeight: '700', marginBottom: '30px', color: '#333' }}>
        Admin Profile
      </h2>

      <div style={{ background: 'white', padding: '30px', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
        <form onSubmit={handleUpdate}>
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', fontWeight: '600', marginBottom: '8px', color: '#333' }}>
              Name
            </label>
            <input
              type="text"
              value={profile.name}
              onChange={(e) => setProfile({...profile, name: e.target.value})}
              style={{
                width: '100%',
                padding: '12px 16px',
                border: '2px solid #ddd',
                borderRadius: '8px',
                fontSize: '14px'
              }}
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', fontWeight: '600', marginBottom: '8px', color: '#333' }}>
              Email
            </label>
            <input
              type="email"
              value={profile.email}
              onChange={(e) => setProfile({...profile, email: e.target.value})}
              style={{
                width: '100%',
                padding: '12px 16px',
                border: '2px solid #ddd',
                borderRadius: '8px',
                fontSize: '14px'
              }}
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', fontWeight: '600', marginBottom: '8px', color: '#333' }}>
              Role
            </label>
            <input
              type="text"
              value={profile.role}
              disabled
              style={{
                width: '100%',
                padding: '12px 16px',
                border: '2px solid #ddd',
                borderRadius: '8px',
                fontSize: '14px',
                background: '#f8f9fa',
                color: '#666'
              }}
            />
          </div>

          <button
            type="submit"
            className="view-btn"
            style={{ width: '100%', padding: '14px', fontSize: '16px', fontWeight: '600' }}
          >
            Update Profile
          </button>
        </form>
      </div>

      {dialog && <CustomDialog message={dialog.message} type={dialog.type} onClose={dialog.onClose} />}
      </div>
    </>
  );
}

export default AdminProfile;
